import { castToSnapshot, types } from 'mobx-state-tree';
import { Organization } from './Organization';
export const OrganizationsStore = types.model('OrganizationStore', {
  organizations: types.array(types.late(() => Organization))
}).views(self => ({
  get orgIds() {
    return self.organizations.reduce((acc, n) => {
      acc[n.id] = true;
      return acc;
    }, {} as Record<string, boolean>);
  }
})).actions(self => ({
  pushOrganizations(organizations) {
    if (Object.keys(self.orgIds).length === 0) {
      self.organizations.replace(castToSnapshot(organizations));
      return organizations;
    }
    organizations.forEach(o => {
      if (!self.orgIds[o.id]) {
        self.organizations.push(o);
      }
    });
    return organizations;
  }
}));
export const organizationsStore = OrganizationsStore.create({
  organizations: []
});